import { IExpertSystemOrderByRecipient } from '@nkr/models/index';

export enum ActionStatus {
    Pending = 0,
    Confirm = 1,
    Completed = 2,
    Dismissed = 3
}

export interface IExpertSystemRecipientDonor extends IExpertSystemOrderByRecipient {
    standardVoucher: ActionStatus,
    kpdPair: ActionStatus,
    internalDirect: ActionStatus,
    internalDirectSurgeryDate: string,
    validInternalDirectSurgeryDate: boolean,
    withdrawDonor: ActionStatus,
}